import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getNotasFiscais, { getAllNotaFiscal, getNotaFiscal } from "../queries/getNotasFiscais";

export default function useGetNotasFiscais(search?: string, page: number = 1) {
  const resultQuery = useQuery(
    [`${URLS.NOTA_FISCAL_API}`, {
      params: { search, page }
    }],
    () => getNotasFiscais(search, page),
  );

  return resultQuery;
}


export function useGetNotaFiscal(notaFiscalId: number) {
  const resultQuery = useQuery([`${URLS.NOTA_FISCAL_API}/${notaFiscalId}`], () =>
  getNotaFiscal(notaFiscalId)
  );

  return resultQuery;
}


export function useGetAllNotaFiscal(search?: string) {
  const resultQuery = useQuery(
    search ? [`${URLS.NOTA_FISCAL_API}`, {
      params: {search}
    }] : [URLS.NOTA_FISCAL_API],
    () => getAllNotaFiscal(search),
    {
      onSuccess: (data) => {
        return data;
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return resultQuery;
}
